import get from "lodash/get";
import chain from "lodash/chain";
import PropTypes from "prop-types";
import React from "react";
import cx from "classnames";

const PAGES = {
  "Volume & Intensity": "/dashboard/metrics/volume-intensity",
  "Baseline Volume & Relative Intensity":
    "/dashboard/metrics/baseline-volume-relative-intensity",
  "Over/Under Baseline Volume": "/dashboard/metrics/over-under-baseline",
  "Volume Split by Core Lift": "/dashboard/metrics/volume-split-core-lift",
  "Personal Record Table": "/dashboard/metrics/record-table",
  "Number of Lifts": "/dashboard/metrics/number-of-lifts",
  "Primary & Secondary Volume Split":
    "/dashboard/metrics/core-accessory-volume-split",
  "1RM Estimation": "/dashboard/metrics/rep-max-estimator",
  "RPE Custom Tables": "/dashboard/metrics/rpe-table",
  "Custom Metric Reports": "/dashboard/metrics/custom",
};
function MetricsNav(
  props,
  {
    locals: {
      pathname,
      search,
      activeUser,
      activeUserToRequest,
      query: { athlete },
    },
  }
) {
  let pages = chain(PAGES);

  const intensityMeasure =
    get(activeUserToRequest, "intensityMeasure", "rpe") === "rpe" ? "RPE" : "RiR";

  return (
    <div className="Heading-Nav" tabIndex="-1">
      <span>Metrics</span>
      <img src="/img/icons/chevron-down.svg" className="chevron-metrics" />
      <div className="dropdown nav">
        {pages
          .map((url, page) => {
            url = athlete ? url.replace("/dashboard", "/athlete-portal") : url;
            return (
              <li key={page}>
                <a
                  className={cx({ active: url === pathname })}
                  href={`${url}${search || ""}`}
                >
                  {page === "RPE Custom Tables"
                    ? `${intensityMeasure} Custom Tables`
                    : page}
                </a>
              </li>
            );
          })
          .value()}
      </div>
    </div>
  );
}

MetricsNav.contextTypes = { locals: PropTypes.object };

export default MetricsNav;
